<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.LOCALIZATIONS_PAGE_TITLE | translate }}</span>
</div>

<div class="row">
  <div class="c-details col">
    <div class="c-details__action-button u-mt--large">
      <button
        (click)="openCreateLangModal()"
        type="button"
        class="button button-primary button-block u-mobile">
        {{ localizationConstants.LOCALIZATIONS_CREATE | translate }}
      </button>
      <button
        (click)="openCreateLangModal()"
        type="button"
        class="button--sm button-primary u-tablet">
        {{ localizationConstants.LOCALIZATIONS_CREATE | translate }}
      </button>
    </div>
  </div>
</div>

<div [hidden]="!dataSource.data.length || isLoading">
  <div class="row">
    <div class="col col-sm-4">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource.filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />
          <input
            *ngIf="dataSource.filter"
            id="languages-search-clear"
            (click)="dataSource.filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
          <input
            *ngIf="!dataSource.filter"
            id="languages-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="u-scroll--horizontal">
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          class="c-table col-md-4">
          <ng-container matColumnDef="code">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="10%">
              <span class="c-table__column-title">{{
                localizationConstants.LOCALIZATIONS_ISO_CODE | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let l">
              {{ l.code }}
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="30%">
              <span class="c-table__column-title">{{
                localizationConstants.LOCALIZATIONS_NAME | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let l">
              <span
                *ngIf="!l.isRenaming"
                class=""
                >{{ l.name }}</span
              >
              <span *ngIf="l.isRenaming">
                <input
                  [(ngModel)]="l.name"
                  type="text"
                  class="c-input c-input--gamma" />
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef
              width="20%"></th>
            <td
              mat-cell
              *matCellDef="let l"
              class="action">
              <button
                *ngIf="!l.isRenaming && isUserAdmin"
                type="button"
                value="l.isActive"
                class="button--sm button-block"
                (click)="toggleActive(l)"
                [disabled]="l.isItemLoading"
                [class.button-primary]="l.isActive"
                [class.button-secondary]="!l.isActive"
                [disabled]="localizationService.isDefaultLanguage(l.code)">
                <app-loading-icon *ngIf="l.isItemLoading"></app-loading-icon>
                <span *ngIf="!l.isItemLoading">{{
                  (l.isActive
                    ? localizationConstants.BUTTON_DEACTIVATE
                    : localizationConstants.BUTTON_ACTIVATE
                  ) | translate
                }}</span>
              </button>
              <button
                *ngIf="l.isRenaming"
                type="button"
                class="button--sm button-primary button-block"
                (click)="updateLanguage(l)"
                [disabled]="l.isItemLoading">
                <app-loading-icon *ngIf="l.isItemLoading"></app-loading-icon>
                <span *ngIf="!l.isItemLoading">{{
                  localizationConstants.BUTTON_SAVE | translate
                }}</span>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="action2">
            <th
              mat-header-cell
              *matHeaderCellDef
              width="20%"></th>
            <td
              mat-cell
              *matCellDef="let l"
              class="action">
              <button
                *ngIf="!l.isRenaming"
                type="button"
                (click)="l.isRenaming = !l.isRenaming"
                class="button--sm button-secondary button-block"
                [disabled]="l.isItemLoading">
                {{ localizationConstants.BUTTON_RENAME | translate }}
              </button>
              <button
                *ngIf="l.isRenaming"
                type="button"
                (click)="l.isRenaming = !l.isRenaming"
                class="button--sm button-secondary button-block"
                [disabled]="l.isItemLoading">
                {{ localizationConstants.BUTTON_CANCEL | translate }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="action3">
            <th
              mat-header-cell
              *matHeaderCellDef
              width="20%"></th>
            <td
              mat-cell
              *matCellDef="let l"
              class="action">
              <button
                *ngIf="!l.isRenaming"
                [routerLink]="[routeNameConstants.ADMIN_LOCALIZATION, l.code]"
                type="button"
                class="button--sm button-secondary button-block"
                [disabled]="l.isItemLoading">
                {{ localizationConstants.BUTTON_EDIT | translate }}
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['code', 'name', 'action1', 'action2', 'action3']"></tr>
          <tr
            mat-row
            *matRowDef="let l; columns: ['code', 'name', 'action1', 'action2', 'action3']"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
